import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiLoginService from '@/services/banzai-login.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiLogin = new BanzaiLoginService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiLogin: BanzaiLoginService;
  }
}
